; (function () {
	"use strict";
	function BjuiResourceSlider() {
		var fn = {
			init: function () {
				fn.initSliders();
			},

			initSliders: function() {
				jQuery('.resources-slider .splide').each(function(index, element) {
					fn.initSlider(element);
					console.log('initting');
				})
			},

			initSlider: function (element) {
				let splide = new Splide(element, {
					perPage: 4,
					fixedWidth: '288px',
					perMove: 4,
					gap: '1rem',
					type: 'loop',
					pagination: false,
					arrows: false,
					breakpoints: {
						1000: {
							perPage: 3,
							perMove: 3,
						}, 800: {
							perPage: 2,
							perMove: 2,
							fixedWidth: '240px',
						},
						500: {
							gap: '0',
							perPage: 1.5,
							perMove: 1,
						},
						classes: {
						},
					}
				}).mount();


				let prevButton = element.querySelector('.resources-slider__nav-button--prev');
				let nextButton = element.querySelector('.resources-slider__nav-button--next');

				// Add event listeners
				prevButton.addEventListener('click', function () {
					splide.go('<'); // Move to the previous slide
				});
				nextButton.addEventListener('click', function () {
					splide.go('>'); // Move to the next slide
				});
			},
		}
		jQuery(document).ready(fn.init);
	}
	new BjuiResourceSlider();
})();